import { getRequest } from 'Services/baseRequests/getRequest'
import { RequestResponse } from 'Services/apiResponseTypes'

type ApiEmployerMetaField = {
  id: number
  field_name: string
  required: boolean
  unique: boolean
}

export type EmployerMetaField = {
  id: number
  fieldName: string
  required: boolean
  unique: boolean
}

type GetEmployerMetaFieldsResponse = RequestResponse<ApiEmployerMetaField[]>

export const getEmployerMetaFields = async (employerId: number): Promise<EmployerMetaField[]> => {
  const response = await getRequest<GetEmployerMetaFieldsResponse>(
    `/employers/${employerId}/meta_fields`
  )

  return (
    response?.data?.map((field) => ({
      id: field.id,
      fieldName: field.field_name,
      required: field.required,
      unique: field.unique
    })) ?? []
  )
}
